var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPopupHexAgons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 10,
    fill: "#EA7600",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.614 9.857a.75.75 0 0 1 .772 0l5 3a.75.75 0 0 1 .364.643v6a.75.75 0 0 1-.364.643l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.364-.643v-6a.75.75 0 0 1 .364-.643l5-3zM2.75 13.925v5.15L7 21.625l4.25-2.55v-5.15L7 11.375l-4.25 2.55z",
    fill: "#EA7600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.614 9.857a.75.75 0 0 1 .772 0l5 3a.75.75 0 0 1 .364.643v6a.75.75 0 0 1-.364.643l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.364-.643v-6a.75.75 0 0 1 .364-.643l5-3zm-3.864 4.068v5.15l4.25 2.55 4.25-2.55v-5.15L17 11.375l-4.25 2.55z",
    fill: "#EA7600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.614.857a.75.75 0 0 1 .772 0l5 3a.75.75 0 0 1 .364.643v6a.75.75 0 0 1-.364.643l-5 3a.75.75 0 0 1-.772 0l-5-3a.75.75 0 0 1-.364-.643v-6a.75.75 0 0 1 .364-.643l5-3zM7.75 4.925v5.15l4.25 2.55 4.25-2.55v-5.15L12 2.375l-4.25 2.55z",
    fill: "#EA7600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupHexAgons);
export default __webpack_public_path__ + "static/media/popupHexAgons.da23edd765ca084ac3fd5f74a685bfba.svg";
export { ForwardRef as ReactComponent };